module.exports = __webpack_public_path__ + "media/bootstrap-icons/slash-9a34b7f5.svg";